import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Content from "./Content";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../store";
import {
  getFullEvidenceInDataPeriods,
  hideClassWideNeedsModal,
  hidePreClassWideNeedsModal,
  setNoClassWideNeeds,
} from "../../../../../../store/onboarding/actions";

import BehaviourContent from "./BehaviourContent";
import LoadingIndicator from "../../../../../common/onboarding/LoadingIndicator";
import { EvidenceType } from "../../../../../../store/onboarding/types";

type OwnProps = {};

type Props = OwnProps;

const ClassWideNeedsModal: FunctionComponent<Props> = (props) => {
  const [isShowBehaviour, setIsShowBehaiour] = useState(false);
  const [isSwitchVisible, setSWitchVisible] = useState(false);
  const [isPrimaryScreening, setIsPrimaryScreening] = useState(false);
  const [isBehaviourScreening, setIsBehaviourScreening] = useState(false);
    

  const dispatch = useDispatch();
  const showModal = useSelector(
    (s: ApplicationState) => s.onboarding.modalsState.showClassWideNeedsModal
  );

  const evidencePeriodData = useSelector(
    (s: ApplicationState) => s.onboarding.evidencePeriodData
    );
    
  const fullEvidenceInDataPeriod = useSelector(
    (s: ApplicationState) => s.onboarding.fullEvidenceInDataPeriod);
  
  const { getFullEvidenceInDataPeriod } = useSelector(
    (s: ApplicationState) => s.onboarding.isLoading);

    useEffect(() => {
      if(showModal) {
        if(evidencePeriodData) {
          if(evidencePeriodData!.evidence_column_groups!.length) {
            dispatch(getFullEvidenceInDataPeriods());
            dispatch(hidePreClassWideNeedsModal());
          }
          
        }
      }
    },[showModal])
    
    useMemo(() => {
      if(fullEvidenceInDataPeriod) {
        const assessmentFound = {
          'dessa': 0,
          'dibels':0
        }
        for (let i = 0; i < fullEvidenceInDataPeriod!.evidence_column_groups!.length; i++) {
          const element = fullEvidenceInDataPeriod?.evidence_column_groups[i];
          if(element.assessment && element.assessment.is_system_assessment && element.evidence_columns.every((ec) => ec.evidence_type == EvidenceType.Data)) {
            if(element.assessment.special_case?.toLowerCase().includes('dessa')) {
              assessmentFound['dessa'] = assessmentFound['dessa'] + 1
            }
            if(element.assessment.special_case?.toLowerCase().includes('dibels')) {
              assessmentFound['dibels'] = assessmentFound['dibels'] + 1
            }
            if(element.is_primary_screening) {
              setIsPrimaryScreening(element.is_primary_screening);
            }
            if(element.is_behaviour_primary_screening) {
              setIsBehaviourScreening(element.is_behaviour_primary_screening); 
            }
            if((element.is_primary_screening == false) && (element.is_behaviour_primary_screening == false)) {
              dispatch(setNoClassWideNeeds(true));
            }
          }
        }
        
        if(assessmentFound['dibels'] && assessmentFound['dessa']){
          setSWitchVisible(true);
        }
        if(assessmentFound['dibels'] && !assessmentFound['dessa']) {
          setIsShowBehaiour(false);
          setSWitchVisible(false);
        } else if(!assessmentFound['dibels'] && assessmentFound['dessa']) {
          setIsShowBehaiour(true);
          setSWitchVisible(false);
        }
      }
    },[fullEvidenceInDataPeriod, isShowBehaviour])

  const handleHide = () => {
    if(fullEvidenceInDataPeriod) {
      for (let i = 0; i < fullEvidenceInDataPeriod!.evidence_column_groups.length; i++) {
        const ecg = fullEvidenceInDataPeriod?.evidence_column_groups[i];
        for (let j = 0; j < ecg!.evidence_columns.length; j++) {
          const ec = ecg!.evidence_columns[j];
          for (let k = 0; k < ec.student_entries.length; k++) {
            for (let l = 0; l < fullEvidenceInDataPeriod!.student_rows.length; l++) {
              const studentRow = fullEvidenceInDataPeriod!.student_rows[l];
              if(studentRow.student.id === ec.student_entries[k].student_id) {
                for (let m = 0; m < studentRow.student.teachers!.length; m++) {
                  const teacher = studentRow.student.teachers![m];
                  if(teacher.classes?.some((classes) => classes.name.toLowerCase().includes('unassigned'))) {
                    const classes = teacher.classes?.filter((classes) => !classes.name.toLowerCase().includes('unassigned'));
                    if(!classes.length) {
                      teacher.classes = null;
                    }
                  }
                  
                }
              }
              
            }
  
          }
        }
      }
    }
    dispatch(hideClassWideNeedsModal());
    dispatch(hidePreClassWideNeedsModal());
    setIsShowBehaiour(false);
  };
  return (
    <Modal
      show={showModal}
      onHide={handleHide}
      animation={false}
      size="lg"
      backdrop="static"
      keyboard={false}
      backdropClassName="customDarkModalBackdrop in"
      centered
    >
      <Modal.Header closeButton className="purpleModalHeader">
        <Modal.Title>View Class-Wide Needs for Teachers</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-inherit">
        {showModal 
          && getFullEvidenceInDataPeriod 
              ? <LoadingIndicator/>
              : fullEvidenceInDataPeriod 
                  ? <>
                    {isSwitchVisible && 
                      <div className="row col-12 text-right my-3">
                        <Form.Check 
                          type="switch"
                          id="behaviourContent"
                          label="Is Show Behavior"
                          checked={isShowBehaviour ?? false}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            if(checked){
                              setIsShowBehaiour(true);
                            } else {
                              setIsShowBehaiour(false)
                            }
                            // setIsBehaviourScreening(checked);
                            // setIsPrimaryScreening(!checked);
                          }}
                        />
                      </div>
                    }
                    {isShowBehaviour 
                      ? <BehaviourContent /> 
                      : <Content />}
                  </>
                  : ''
        }
        
      </Modal.Body>
    </Modal>
  );
};

export default ClassWideNeedsModal;
